import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MAT_NATIVE_DATE_FORMATS,
  MatNativeDateModule,
  NativeDateAdapter
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaLoaderService, RecaptchaV3Module } from 'ng-recaptcha';
import { provideLottieOptions } from 'ngx-lottie';
import { initializeAppRouter, routes } from './app.routes';
import { httpInterceptorProviders } from './core/interceptors';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { translateLoaderFunc } from './shared/services/language.service';
import { PreloadedRecaptchaApiService } from './shared/services/preloaded-recaptcha-api.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MMM/YYYY'
  },
  display: {
    dateInput: 'DD/MMM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MMM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    MatDatepickerModule,
    MatNativeDateModule,
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'he-IL' },
    { provide: DateAdapter, useClass: NativeDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    provideLottieOptions({
      player: () => import('lottie-web')
    }),
    // provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([loaderInterceptor]), withInterceptorsFromDi()),
    ...httpInterceptorProviders,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppRouter,
      multi: true,
      deps: [HttpClient] // TODO: change to inject(HttpClient)
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    importProvidersFrom([
      RecaptchaV3Module,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: translateLoaderFunc,
          deps: [HttpClient] // TODO: change to inject(HttpClient)
        }
      })
    ]),
    provideRouter(routes),
    {
      provide: RecaptchaLoaderService,
      useValue: new PreloadedRecaptchaApiService()
    }
  ]
};
